export enum RequestMethod {
  PATCH = 'PATCH',
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
}
